import objectLength from '@/services/mixins/objectLength'

export default {
	mixins: [
		objectLength
	],
	methods: {
		isPlanExceed (value, item) {
			if (this.objectLength(this.userTeam)) {
				return value >= this.userTeam.plan.limits[item]
			}
		}
	}
}
